import React from 'react';
import Icon from 'components/icons/Icon';

const Tag = (props) => {
  return (
    <Icon width="16px" height="16px" {...props}>
      <path
      fill="currentColor"
      d="m8.528 14.284 5.899-5.9c.495-.494.573-.81.573-1.562V4.567c0-.698-.167-.978-.704-1.51l-1.356-1.36c-.537-.53-.812-.697-1.51-.697H9.167c-.746 0-1.05.09-1.546.585L1.716 7.478c-.949.949-.96 1.998 0 2.959l3.857 3.847c.961.955 2.006.955 2.955 0Zm-.955-1.223c-.346.346-.686.352-1.045 0L2.94 9.482c-.364-.358-.34-.71-.006-1.044L8.72 2.664c.12-.12.215-.179.394-.179h2.233c.167 0 .287.06.394.167l1.606 1.605a.534.534 0 0 1 .167.394v2.23c0 .197-.047.293-.16.406l-5.78 5.774Zm3.045-6.764a.91.91 0 0 0 .925-.919.91.91 0 0 0-.925-.924.91.91 0 0 0-.925.924c0 .513.4.919.925.919Z"
    />
    </Icon>
  );
};

export default Tag;
